export default __webpack_public_path__ + "static/media/lobby.700f937f.jpg";